import React from "react";
import Modal from "./Modal";
import Button from "./Button";
import "../../styles/form.css";

export default function ConfirmModal({
  isOpen,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
  confirmVariant = "danger",
}) {
  if (!isOpen) return null;

  const confirmBtnVariant =
    confirmVariant === "danger" ? "danger" : confirmVariant === "primary" ? "primary" : "secondary";

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="modal-body">
        {title && <h3 className="modal-status-title">{title}</h3>}
        {message && <p className="modal-message">{message}</p>}

        <div className="modal-actions gap-4 d-flex" aria-live="polite">
          <Button
            onClick={onConfirm}
            variant={confirmBtnVariant}
            className="btn-md me-2"
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmLabel}
          </Button>
          <Button
            onClick={onCancel}
            variant="cancel"
            className="btn-md"
            disabled={isLoading}
          >
            {cancelLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

